import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { IMG_1, IMG_2, IMG_4, IMG_5, IMG_6, IMG_7, IMG_8, IMG_9 } from "@/lib/images";
import { ExternalLink, CalendarDays } from "lucide-react";

const posts = [
  {
    title: "NM Blue Cross Blue Shield",
    date: "June 26, 2021",
    imgs: [IMG_4, IMG_5, IMG_6],
    body: "UDC has continued its collaboration with Blue Cross Blue Shield after a year's wait due to COVID-19! We are glad to be working with Blue Cross Blue Shield. It's good to be back!",
    linkLabel: "NM Blue Cross Blue Shield",
    url: "https://www.bcbsnm.com/",
  },
  {
    title: "Umoja ABQ Health Fair",
    date: "February 27, 2021",
    imgs: [IMG_1, IMG_2],
    body: "Umoja ABQ has collaborated with UDC to create a health fair event for local refugees! Umoja ABQ's mission is to empower refugee women with tools and resources to enhance and develop their skills through education, so they can successfully integrate and become self-sufficient in American society while maintaining their cultural values.",
    linkLabel: "Umoja ABQ",
    url: "https://www.umojaabq.org/",
  },
  {
    title: "NM Dental Hygiene Day at the Legislature — State Capitol",
    date: "February 14, 2020",
    imgs: [IMG_7, IMG_8, IMG_9],
    body: "Dental Hygienist Advocacy Day at the NM State Capitol in Santa Fe! Thank you to our lobbyist Debbie Maestas Traynor, former NMDHA President Valoree Althoff, and legislative chair Barbara Posler. Many hygienists and UNM senior dental hygiene students participated! Darly Barkley served as the 2018–2020 treasurer for the High Desert ADHA District.",
    linkLabel: "High Desert ADHA District",
    url: "https://www.nmdha.org/about/hddha",
  },
];

function Gallery({ imgs, title }) {
  return (
    <div className="md:col-span-2 grid grid-cols-2 gap-1 bg-[#F6F2FA]">
      {imgs.map((img, idx) => {
        const wide = idx === 0 || imgs.length === 2;
        return (
          <img
            key={idx}
            src={img}
            alt={`${title} ${idx + 1}`}
            className={`w-full object-cover ${wide ? "col-span-2 h-56" : "col-span-1 h-32"}`}
          />
        );
      })}
    </div>
  );
}

export default function Blog() {
  return (
    <div className="App">
      <Navbar />
      <section className="max-w-5xl mx-auto px-6 pt-32 pb-20">
        <p className="label text-sm uppercase tracking-[0.15em] text-[#78698A] font-semibold">UDC Blog</p>
        <h1 className="font-serif text-5xl text-[#2D2336] mt-3">What UDC does in the community</h1>
        <p className="text-lg text-[#5C5166] mt-4">An ongoing series of what Utopia Dental Care does. Learn more about us!</p>

        <div className="mt-12 space-y-10" data-testid="blog-list">
          {posts.map((p, i) => (
            <article key={i} className="bg-white border border-[#E5DEEB] rounded-2xl overflow-hidden shadow-sm grid md:grid-cols-5">
              <Gallery imgs={p.imgs} title={p.title} />
              <div className="md:col-span-3 p-8">
                <p className="flex items-center gap-2 text-sm text-[#78698A]"><CalendarDays className="h-4 w-4" /> {p.date}</p>
                <h2 className="font-serif text-3xl text-[#2D2336] mt-2">{p.title}</h2>
                <p className="text-[#5C5166] leading-relaxed mt-4">{p.body}</p>
                <a href={p.url} target="_blank" rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-[#6B4C8A] font-medium mt-4 hover:underline">
                  {p.linkLabel} <ExternalLink className="h-4 w-4" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
